module.exports = __webpack_public_path__ + "img/Camada 7 copiar.ddc7d70d.png";